import React from 'react'
import { Select } from 'semantic-ui-react'
import { map } from 'lodash'

import countries, { names } from './countries'

export default class Countries extends React.PureComponent {
  static defaultProps = {
    options: map(countries, (country) => {
      const flagName = country.id.toLowerCase();

      return {
        key: country.id, value: country.id, flag: names.indexOf(flagName) > -1 ? flagName : undefined , text: country.name
      }
    })
  };
  render() {
    return <Select { ...this.props } />
  }
}

